<script>
import buttonGrid from '@expressive-analytics/vue-survey/lib/buttonGrid.vue'
import {maxLength} from 'vuelidate/lib/validators'
import moment from 'moment'
import AudioManager from 'components/lib/AudioManager.js'
export default {
  props: {
    "buttons":{
      type: Array,
      default: ()=>{
        return [
          {name:"1"},{name:"2"},{name:"3"},
          {name:"4"},{name:"5"},{name:"6"},
          {name:"7"},{name:"8"},{name:"9"},
          {},{name:"0"},{icon:'fa fa-backspace',btn_class:'yellow-button',action:"delete"}
        ]
      }
    }
  },
  extends: buttonGrid,
  validations(){
    let validations = this.validations()
    validations.val.maxLength = maxLength(3)
    return validations
  },
  mounted(){
    let chunk = this.chunk

    let level = chunk.get("level")
    setTimeout(()=>{
      let d = AudioManager.playAudio(level)
      chunk.set("trial.prompt",d)
      chunk.set("trial.start_at_ms",moment.utc().format("x"))
    },3000)

    let side = chunk.get("side.side")
    this.q.name = (side=="R"?"Right Ear":"Left Ear")
    chunk.set("trial.seq",this.q.seq)
    chunk.set("trial.side",side)
    chunk.set("trial.level",level)
    this.set("") // clear response from last trial
  }
}
</script>
